import createClient from 'openapi-fetch'
import type { paths } from './schema'

/**
 * Same-origin in both development and production: Vite proxies `/api` to the
 * backend in dev, and FastAPI serves this build in prod. So there is no base
 * URL to configure and no environment variable to get wrong.
 *
 * No `baseUrl`: the generated paths already carry the `/api/v1` prefix,
 * because that is where the OpenAPI document declares them.
 */
export const api = createClient<paths>()
